import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resetUser, validatePassword, verifyRecaptchaToken, verifyRecaptchaTokenv2 } from '../core-actions'
import CoreResetPassword from '../components/core-reset-password'

const mapStateToProps = state => {
  return {
    theme: state.core.theme
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      resetUser,
      validatePassword,
      verifyRecaptchaToken,
      verifyRecaptchaTokenv2
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoreResetPassword)
